// extracted by mini-css-extract-plugin
export default {"ActivityTagsFilter":"style_ActivityTagsFilter__niAYS"};